import { Button, IButtonProps } from 'components/button';
import styles from '../highlight.module.scss';

export interface IEmptyTabProps {
	content: string;
	button?: IButtonProps;
}

export const EmptyTab = ({ content, button }: IEmptyTabProps): React.JSX.Element => (
	<div className={styles.empty}>
		<p>{content}</p>
		{button && button.href && button.title && <Button variant="secondary" {...button} />}
	</div>
);

export default EmptyTab;
